<template>
  <b-modal :visible="show" :hide-header="true" centered id="modal-furto-simples-qualificado" size="md"
    :hide-footer="true">
    <div class="float-right"><img @click="hide" class="close-modal" src="img/x-modal.svg" /></div>
    <div class="text-justify mt-3">
      <h5 class="bold-modal">Furto simples e furto qualificado</h5>
      <!--
        Textos legais SUSEP — vêm de config.js (fonte única do app).
        Ver specs/001-avisos-legais-susep. NÃO reescrever a redação aqui.
      -->
      <div class="mb-3">
        <strong>Furto qualificado (coberto)</strong>
        <div>{{ config.TEXTO_LEGAL_FURTO_QUALIFICADO }}</div>
      </div>

      <div class="mb-2">
        <strong>Furto simples</strong>
        <div>{{ config.TEXTO_LEGAL_FURTO_SIMPLES }}</div>
        <div class="mt-2 texto-sem-cobertura">
          {{ config.TEXTO_LEGAL_FURTO_SIMPLES_SEM_COBERTURA }}
        </div>
      </div>

      <div class="center-modal mt-5">
        <button type="button" class="continue-btn-modal" @click="hide"> Entendi </button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import config from "../../config";

export default {
  props: ["show"],
  data() {
    return { config };
  },
  methods: {
    hide() {
      this.$emit("hide");
    },
  },
};
</script>
<style>
#modal-furto-simples-qualificado___BV_modal_content_ {
  border-radius: 12px !important;
  padding: 25px;
  padding-top: 15px;
  color: #78849E;
}

.texto-sem-cobertura {
  font-weight: 700;
  color: #C0362C;
}
</style>
